import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("rx_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const saveAuth = (token, user) => {
  localStorage.setItem("rx_token", token);
  localStorage.setItem("rx_user", JSON.stringify(user));
};

export const clearAuth = () => {
  localStorage.removeItem("rx_token");
  localStorage.removeItem("rx_user");
};

export const getUser = () => {
  const u = localStorage.getItem("rx_user");
  return u ? JSON.parse(u) : null;
};

export const getToken = () => localStorage.getItem("rx_token");

export const VERTICALS = [
  { id: "transport", name: "Transport & Delivery", tag: "Rides, Packages, Food, Errands", color: "#1E3A8A", icon: "Car" },
  { id: "home", name: "Home", tag: "Cleaning, Repairs, Maintenance", color: "#9A3412", icon: "House" },
  { id: "concierge", name: "Concierge", tag: "Personal Assistance", color: "#4C1D95", icon: "Bell" },
  { id: "business", name: "Business", tag: "Office & Logistics", color: "#334155", icon: "Buildings" },
];

export const VERTICAL_MAP = Object.fromEntries(VERTICALS.map(v => [v.id, v]));
